import { render, staticRenderFns } from "./BrowseGoalsFiltersDisplay.vue?vue&type=template&id=061c59a6&scoped=true"
import script from "./BrowseGoalsFiltersDisplay.vue?vue&type=script&lang=js"
export * from "./BrowseGoalsFiltersDisplay.vue?vue&type=script&lang=js"
import style0 from "./BrowseGoalsFiltersDisplay.vue?vue&type=style&index=0&id=061c59a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061c59a6",
  null
  
)

export default component.exports